import { ComponentProps, FC, forwardRef } from "react";
import Link from "next/link";
import { cn } from "../../utils/cn";
import { cva } from "class-variance-authority";

const styles = cva([
  "cursor-pointer outline-none focus-visible:ring-link-ring-focus focus-visible:ring-[length:var(--link-ring-width-focus)]",
]);

type NextLinkProps = Omit<ComponentProps<typeof Link>, "href"> & {
  href?: string;
};

export const NextLink: FC<NextLinkProps> = forwardRef<
  HTMLAnchorElement,
  NextLinkProps
>((props, ref) => {
  const { href, className, prefetch = false, ...rest } = props;

  if (href) {
    return (
      <Link
        ref={ref}
        href={href}
        prefetch={prefetch}
        className={cn(styles(), className)}
        {...rest}
      />
    );
  }

  return (
    <div
      ref={ref as any}
      className={cn(styles(), className)}
      {...(rest as any)}
    >
      {rest.children}{" "}
    </div>
  );
});
NextLink.displayName = "NextLink";
